import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const steps = [
  {
    num: "01",
    title: "Realtidssynk mellan kök och servering",
    desc: "Köket uppdaterar status på rätter (Tillgänglig / Slutsåld) och servispersonalen ser ändringarna direkt i sitt gränssnitt – utan att behöva fråga köket.",
  },
  {
    num: "02",
    title: "Beställningsassistent med inköpslistor",
    desc: "Systemet kopplar ihop rätter → komponenter → ingredienser och genererar automatiskt inköpslistor grupperade per leverantör. Stöd för röstinmatning för snabbare beställningar.",
  },
  {
    num: "03",
    title: "Prep-listor och daglig planering",
    desc: "Användare väljer vilka rätter som ska förberedas. Systemet bryter ner dem i komponenter per förberedelseområde, med prioritering och avbockning i realtid.",
  },
];

const HowItWorksSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "center center"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.6], [0, 1]);
  const y = useTransform(scrollYProgress, [0, 0.6], [50, 0]);

  return (
    <section
      ref={ref}
      id="how-it-works"
      className="bg-white py-[100px] md:py-[120px] px-6"
    >
      <motion.div
        style={{ opacity, y }}
        className="max-w-[640px] mx-auto w-full"
      >
        <h2 className="text-[clamp(1.75rem,3.5vw,2.375rem)] font-bold tracking-tight text-foreground leading-[1.18] text-balance">
          Så fungerar det i praktiken
        </h2>

        <div className="mt-12 space-y-4">
          {steps.map((step) => (
            <div key={step.num} className="soft-card p-6 md:p-7 flex items-start gap-5">
              <span
                className="text-sm font-semibold tabular-nums shrink-0 mt-0.5"
                style={{ color: "#026133" }}
              >
                {step.num}
              </span>
              <div className="space-y-1.5">
                <h3 className="text-[15px] font-semibold text-foreground">
                  {step.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "rgba(15,23,42,0.7)" }}
                >
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default HowItWorksSection;
